import './eventimage.less'

import {classes, Component} from '@codeurs/front'
import {format} from 'date-fns'
import m from 'mithril'

export type EventDateType = {
	start_date: string | Date
	class?: string
	mod?: 'small'
}
export default class EventImage extends Component<EventDateType> {
	view() {
		const {start_date, class: className, mod} = this.attrs
		return m('.eventimage', classes(className, {mod}), [
			start_date && m('.eventimage-month', this.getMonth(start_date)),
			start_date && m('.eventimage-day', this.getDay(start_date))
		])
	}
	getMonth(start_date) {
		return format(start_date, "MMM. 'YY")
	}
	getDay(start_date) {
		return format(start_date, 'DD')
	}
}
